export default __webpack_public_path__ + "static/media/mint-gen-4.6aaa7c87.png";